import { ClientLogoConfig } from "./types";

export default function ClientLogo(props: ClientLogoConfig) {
  return (
    <div className="clientLogo_details">
      <span className="clientLogo_details_img">
        {props.clientLogoUrl && <img src={props.clientLogoUrl} alt={props.clientName} />}
      </span>
      {props.clientName && <b className="clientLogo_details_name">{props.clientName}</b>}
    </div>
  );
}
